import { GoToWaypointAction, Mission, MissionAction, MissionActionType, TakeOffAction } from '../types/Mission';
import { apiClient } from './ApiService';
import { MissionCreateApiResponse, MissionCreateRequest, MissionStepNavKind } from './types/api.generated';

const actionTypeMapping: Record<MissionActionType, MissionStepNavKind> = {
  [MissionActionType.TakeOff]: 'TAKEOFF',
  [MissionActionType.GoToWaypoint]: 'WAYPOINT',
  [MissionActionType.Orbit]: 'ORBIT',
  [MissionActionType.ReturnToBase]: 'RTH',
  [MissionActionType.Land]: null
};

const getSpeedFromAction: (action: MissionAction) => number = (action) => {
  if (action.type === MissionActionType.TakeOff) {
    return (action as TakeOffAction).verticalSpeed;
  }
  if (action.type === MissionActionType.GoToWaypoint) {
    return (action as GoToWaypointAction).speed;
  }
  return 0;
};

const getLocationFromAction: (action: MissionAction) => [number, number] = (action) => {
  if (action.type === MissionActionType.TakeOff) {
    return (action as TakeOffAction).location;
  }
  if (action.type === MissionActionType.GoToWaypoint) {
    return (action as GoToWaypointAction).location;
  }
  return [0, 0];
};

const getAltitudeFromAction: (action: MissionAction) => number = (action) => {
  if (action.type === MissionActionType.TakeOff) {
    return (action as TakeOffAction).altitude;
  }
  if (action.type === MissionActionType.GoToWaypoint) {
    return (action as GoToWaypointAction).altitude;
  }
  return 0;
};

const saveMission = async (mission: Mission): Promise<void> => {
  const missionCreateRequest: MissionCreateRequest = {
    name: mission.name,
    sequences: [
      {
        steps: mission.actions.map((action, index) => ({
          order: index,
          speed_mps: getSpeedFromAction(action).toString(),
          nav_kind: actionTypeMapping[action.type],
          lat: getLocationFromAction(action)[1],
          lon: getLocationFromAction(action)[0],
          alt_m: getAltitudeFromAction(action)
        }))
      }
    ]
  };

  try {
    const response = await apiClient.post<MissionCreateApiResponse>(
      '/drone_commander/missions/create-mission/',
      missionCreateRequest
    );

    if (response.status !== 201) throw new Error(`Unexpected response status: ${response.status}`);
  } catch (error) {
    console.error('Failed to save mission:', error);
    throw error;
  }
};

export const MissionPlanningService = {
  saveMission
};
